import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import ImmutablePropTypes from "react-immutable-proptypes";
import { connect } from "react-redux";

import ModalField from "../../components/modal/ModalField";
import ModalRow from "../../components/modal/ModalRow";
import ModalTabContent from "../../components/modal/ModalTabContent";
import SettingsPropertyGroup from "./SettingsPropertyGroup";
import SettingsReferenceGroup from "./SettingsReferenceGroup";
import SettingsTypeGroup from "./SettingsTypeGroup";

class SettingsDataTab extends PureComponent {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <ModalTabContent scrollable={true}>
        <SettingsTypeGroup {...this.props} />
        <ModalRow>
          <ModalField>
            <SettingsReferenceGroup {...this.props} />
          </ModalField>
          <ModalField>
            <SettingsPropertyGroup {...this.props} />
          </ModalField>
        </ModalRow>
      </ModalTabContent>
    );
  }
}

SettingsDataTab.propTypes = {
  types: ImmutablePropTypes.list.isRequired,
  references: ImmutablePropTypes.list.isRequired,
  properties: ImmutablePropTypes.list.isRequired,
  dispatchLocal: PropTypes.func.isRequired,
  onAdvancedSettingsClick: PropTypes.func.isRequired,
  includeNarrative: PropTypes.bool.isRequired,
  orderedSequenceTypes: ImmutablePropTypes.list.isRequired,
  orderedNarrativeTypes: ImmutablePropTypes.list,
  defaultSequenceType: PropTypes.string.isRequired,
  defaultNarrativeType: PropTypes.string,
  isValid: PropTypes.bool,
  validationError: PropTypes.string
};

const mapDispatchToProps = (_dispatch, _props) => {
  // Note: We are always using dispatchLocal here so that the action only travels
  // back to the Settings Modal.
  // Changes are committed to the root store only when the dialog is confirmed.
  return {};
};

export default connect(null, mapDispatchToProps)(SettingsDataTab);
